<fs-sidenav-menu-items>
  <button 
      fs-sidenav-menu-item 
      *fsAclRead="[{ permission: AclPermission.Admin }]"
      (click)="create()">
    Create New Organization
  </button>
  <button fs-sidenav-menu-item (click)="switch()">Switch Organization</button>
</fs-sidenav-menu-items>
